
import axios from "axios";

const practiceApi = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "https://mockq.wahylab.com/api",
  headers: { "Content-Type": "application/json" },
});

practiceApi.interceptors.request.use(
  (config) => {
    if (typeof localStorage !== "undefined") {
      const token = localStorage.getItem("access_token");
      if (token) {
        config.headers = config.headers || {};
        config.headers.Authorization = `Bearer ${token}`;
      }
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Beginner practice-set workflow
export const getPracticeSets = () =>
  practiceApi.get("/beginner/practice-sets/");

export const startPracticeAttempt = (practiceSetId) =>
  practiceApi.post(`/beginner/practice-sets/${practiceSetId}/start/`);

export const submitPracticeAttempt = (attemptId, answers) =>
  practiceApi.post(`/beginner/practice-attempts/${attemptId}/submit/`, {
    answers,
  });

export const getPracticeHistory = () =>
  practiceApi.get("/beginner/practice-attempts/");

// Practice-only answer review; the backend allows this only for the owner
// of a submitted attempt and never exposes main-exam answers.
export const getPracticeAttemptReview = (attemptId) =>
  practiceApi.get(`/beginner/practice-attempts/${attemptId}/review/`);

// Backward-compatible exports for the existing Practice.jsx page.
// These preserve its previous API contract until that page is migrated.
export const getPracticeQuestions = ({
  examId,
  sectionId,
  count = 10,
} = {}) => {
  const params = { count };
  if (examId != null) params.exam_id = examId;
  if (sectionId != null) params.section_id = sectionId;

  return practiceApi.get("/exams/practice/questions/", { params });
};

export const submitPracticeAnswer = (questionId, payload) =>
  practiceApi.post(
    `/exams/practice/questions/${questionId}/answer/`,
    payload
  );

export default practiceApi;
